import { mergeStyles } from "@fluentui/react";

export const partnerConfigurationListContainerStyles = mergeStyles([{
    width: '100%',
    height: '98dvh'
}]);

export const partnerConfigurationListUserContainerStyles = mergeStyles([{
    marginBottom: '1dvh',
    width: '100%',
    height: '5dvh',
    backgroundColor: '#F0F0F0'
}]);

export const partnerConfigurationAppListContainerStyles = mergeStyles([{
    width: '100%',
    paddingRight: '1dvh',
    height: '56dvh',
    overflowY: 'auto'
}]);

export const partnerConfigurationListTotalContainerStyles = mergeStyles([{
    marginTop: '1dvh',
    width: '100%',
    height: '5dvh',
    backgroundColor: '#F0F0F0'
}]);

//#region GROUPS

export const partnerConfigurationListGroupContainerStyles = mergeStyles([{
    marginBottom: '1dvh',
    width: '100%',
    height: '5dvh',
    backgroundColor: '#7e7d7d',
    borderRadius: '10px'
}]);

export const partnerConfigurationListGroupInnerContainerStyles = mergeStyles([{
    gap: '1dvh',
    padding: '1dvh',
    backgroundColor: '#7e7d7d',
    borderRadius: '5px'
}]);

export const partnerConfigurationListGroupStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.2rem',
    fontWeight: 600,
    color: 'white',
    textAlign: 'left'
}]);

export const xxlPartnerConfigurationListGroupStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.1rem, 2.5vw, 1.2rem)',
    fontWeight: 600,
    color: 'white',
    textAlign: 'left'
}]);

export const xlPartnerConfigurationListGroupStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
    fontWeight: 600,
    color: 'white',
    textAlign: 'left'
}]);

export const lgPartnerConfigurationListGroupStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
    fontWeight: 600,
    color: 'white',
    textAlign: 'left'
}]);

export const mdPartnerConfigurationListGroupStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
    fontWeight: 600,
    color: 'white',
    textAlign: 'left'
}]);

export const smPartnerConfigurationListGroupStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
    fontWeight: 600,
    color: 'white',
    textAlign: 'left'
}]);

//#endregion GROUPS

// export const registerConfigurationAppTileContainerStyles = mergeStyles([{
//     width: '100%',
//     padding: '1dvh',
//     backgroundColor: '#F0F0F0',
//     cursor: 'pointer',
//     borderRadius: '5px'
// }]);

// export const registerConfigurationAppTileContainerSelectedStyles = mergeStyles([{
//     width: '100%',
//     backgroundColor: '#F0F0F0',
//     cursor: 'pointer',
//     borderRadius: '5px',
//     border: '2px solid #a9c963'
// }]);

// export const registerConfigurationAppTileInnerContainerSelectedStyles = mergeStyles([{
//     width: 'inherit',
//     padding: '1dvh',
//     backgroundColor: 'rgba(169, 201, 99, 0.2)'
// }]);

// export const registerConfigurationAppTileTextContainerStyles = mergeStyles([{
//     gap: '0.5dvh',
// }]);

// //#region APP TILE TITLE

// export const titleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: '1.2rem',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const xxlTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.95rem, 2.5vw, 1rem)',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const xlTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.9rem, 2.5vw, 0.95rem)',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const lgTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: '1rem',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const mdTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const smTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.75rem, 2.5vw, 0.8rem)',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// //#endregion APP TILE TITLE

// //#region APP TILE DESCRIPTION

// export const descriptionStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: '1rem',
//     fontWeight: 300,
//     color: '#323130',

//     textAlign: 'left'
// }]);

// export const xxlDescriptionStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.95rem, 2.5vw, 1rem)',
//     fontWeight: 300,
//     color: '#323130',

//     textAlign: 'left'
// }]);

// export const xlDescriptionStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.9rem, 2.5vw, 0.95rem)',
//     fontWeight: 300,
//     color: '#323130',

//     textAlign: 'left'
// }]);

// export const lgDescriptionStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
//     fontWeight: 300,
//     color: '#323130',

//     textAlign: 'left'
// }]);

// export const mdDescriptionStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
//     fontWeight: 300,
//     color: '#323130',

//     textAlign: 'left'
// }]);

// export const smDescriptionStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.75rem, 2.5vw, 0.8rem)',
//     fontWeight: 300,
//     color: '#323130',

//     textAlign: 'left'
// }]);

// //#endregion APP TILE DESCRIPTION

// //#region USER INPUT

// export const registerConfigurationUserInputContainerStyles = mergeStyles([{
//     gap: '1dvh',
//     padding: '1dvh',
//     backgroundColor: '#F0F0F0',
//     borderRadius: '5px'
// }]);

// export const registerConfigurationUserInputTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: '1.2rem',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const xxlRegisterConfigurationUserInputTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(1.1rem, 2.5vw, 1.2rem)',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const xlRegisterConfigurationUserInputTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const lgRegisterConfigurationUserInputTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const mdRegisterConfigurationUserInputTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const smRegisterConfigurationUserInputTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const registerConfigurationUserInputNumberStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: '1.2rem',
//     fontWeight: 400,
//     color: '#323130',

//     textAlign: 'left'
// }]);

// export const xxlRegisterConfigurationUserInputNumberStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(1.1rem, 2.5vw, 1.2rem)',
//     fontWeight: 400,
//     color: '#323130',

//     textAlign: 'left'
// }]);

// export const xlRegisterConfigurationUserInputNumberStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
//     fontWeight: 400,
//     color: '#323130',

//     textAlign: 'left'
// }]);

// export const lgRegisterConfigurationUserInputNumberStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
//     fontWeight: 400,
//     color: '#323130',

//     textAlign: 'left'
// }]);

// export const mdRegisterConfigurationUserInputNumberStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
//     fontWeight: 400,
//     color: '#323130',

//     textAlign: 'left'
// }]);

// export const smRegisterConfigurationUserInputNumberStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
//     fontWeight: 400,
//     color: '#323130',

//     textAlign: 'left'
// }]);

// //#endregion USER INPUT

// //#region PRICE LIST

// export const registerConfigurationPriceListContainerStyles = mergeStyles([{
//     gap: '1dvh',
//     padding: '1dvh',
//     backgroundColor: '#F0F0F0',
//     borderRadius: '5px'
// }]);

// export const registerConfigurationPriceListTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: '1.2rem',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const xxlRegisterConfigurationPriceListTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(1.1rem, 2.5vw, 1.2rem)',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const xlRegisterConfigurationPriceListTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const lgRegisterConfigurationPriceListTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const mdRegisterConfigurationPriceListTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// export const smRegisterConfigurationPriceListTitleStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
//     fontWeight: 600,
//     color: '#2A7DE1',

//     textAlign: 'left'
// }]);

// //#endregion PRICE LIST

// //#region TOTAL

// export const registerConfigurationTotalStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: '1.2rem',
//     fontWeight: 600,
//     color: '#2A7DE1'
// }]);

// export const xxlRegisterConfigurationTotalStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(1.1rem, 2.5vw, 1.2rem)',
//     fontWeight: 600,
//     color: '#2A7DE1'
// }]);

// export const xlRegisterConfigurationTotalStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
//     fontWeight: 600,
//     color: '#2A7DE1'
// }]);

// export const lgRegisterConfigurationTotalStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
//     fontWeight: 600,
//     color: '#2A7DE1'
// }]);

// export const mdRegisterConfigurationTotalStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
//     fontWeight: 600,
//     color: '#2A7DE1'
// }]);

// export const smRegisterConfigurationTotalStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
//     fontWeight: 600,
//     color: '#2A7DE1'
// }]);

// export const registerConfigurationTotalNumberStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: '1rem',
//     fontWeight: 400,
//     color: '#323130'
// }]);

// export const xxlRegisterConfigurationTotalNumberStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
//     fontWeight: 400,
//     color: '#323130'
// }]);

// export const xlRegisterConfigurationTotalNumberStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.95rem, 2.5vw, 1.1rem)',
//     fontWeight: 400,
//     color: '#323130'
// }]);

// export const lgRegisterConfigurationTotalNumberStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
//     fontWeight: 400,
//     color: '#323130'
// }]);

// export const mdRegisterConfigurationTotalNumberStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)',
//     fontWeight: 400,
//     color: '#323130'
// }]);

// export const smRegisterConfigurationTotalNumberStyles = mergeStyles([{
//     fontFamily: 'Nunito',
//     fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)',
//     fontWeight: 400,
//     color: '#323130'
// }]);

// //#endregion TOTAL

// export const registerConfigurationUserInputButtonStyles: IButtonStyles = {
//     root: {
//         color: '#2A7DE1',
//         fontWeight: 700,
//     },
//     icon: {
//         color: '#2A7DE1',
//         fontWeight: 700,
//     },
//     iconHovered: {
//         color: '#0078D4',
//         fontWeight: 700,
//     },
//     iconPressed: {
//         color: '#0078D4',
//         fontWeight: 700,
//     }
// }

// export const registerConfigurationPriceListToggleStyles: IStyleFunctionOrObject<IToggleStyleProps, IToggleStyles> = {
//     root: {
//         marginBottom: '5px'
//     }
// }

// export const registerConfigurationTotalContainerStyles = mergeStyles([{
//     gap: '1dvh',
//     padding: '1dvh',
//     backgroundColor: '#F0F0F0',
//     borderRadius: '5px'
// }]);